  <app-modal-shell [showFooter]="true"
    [dismissLabel]="'general.cancel' | translate"
    (dismiss)="dismiss()">
    <div modalTitle>
      <h2>{{ name() }}</h2>
    </div>
    @if (scheduleSite()?.name; as siteName) {
      <div modalDescription>
        <p>{{ siteName }}</p>
      </div>
    }
    <div class="dialog-shell">
      @if (isUser()) {
        <app-segment-list class="view-segment"
          [segmentValue]="viewSegment()"
          [segmentButtons]="viewSegmentButtons"
          (segmentChanged)="viewSegment.set($event)"></app-segment-list>
      }

      <div class="dialog-content-scroll">
        @if (viewSegment() === 'allocate') {
          <div class="allocation-form">
            @if (scheduleSite() == null || updating()) {
              <app-card class="form-card">
                <app-select-site-picker [labelKey]="'timesheetsReview.filters.site'"
                  [placeholderKey]="'timesheetsReview.filters.site'"
                  [items]="sites$ | async"
                  [selectedSite]="scheduleSite()"
                  (selectedChange)="scheduleSite.set($event)"></app-select-site-picker>
              </app-card>
            }

            <form [formGroup]="formGroup"
              class="allocation-form__body">
              <app-card class="form-card">
                <h4>{{ 'schedule.add.project' | translate }}</h4>
                @if (projects$ | async; as projects) {
                  <app-select-project-picker [labelKey]="'schedule.add.project'"
                    [placeholderKey]="'schedule.add.project'"
                    [items]="projects"
                    [selectedProject]="formGroup.get('project').value"
                    (selectedChange)="onProjectSelected($event)"></app-select-project-picker>
                }
              </app-card>

              <app-card class="form-card">
                <h4>{{ 'schedule.dateRange' | translate }}</h4>
                <div class="form-grid">
                  <div class="form-field">
                    <label>{{ 'schedule.startDate' | translate }}</label>
                    <app-select-day color="secondary"
                      [id]="'selectStartDay'"
                      [format]="'d.M.'"
                      [expand]="''"
                      [minDate]="minDate"
                      [value]="formGroup.get('startDate').value"
                      (changed)="onDateChange($event, 'startDate')"></app-select-day>
                  </div>

                  <div class="form-field">
                    <label>{{ 'schedule.endDate' | translate }}</label>
                    <app-select-day color="secondary"
                      [id]="'selectEndDay'"
                      [format]="'d.M.'"
                      [expand]="''"
                      [minDate]="formGroup.get('startDate').value"
                      [value]="formGroup.get('endDate').value"
                      (changed)="onDateChange($event, 'endDate')"></app-select-day>
                  </div>
                </div>

                <div class="form-grid">
                  <div class="form-field">
                    <label>{{ 'schedule.add.start' | translate }}</label>
                    <button class="picker-button"
                      type="button"
                      id="open-date-start">
                      <span>{{ formGroup.get('start').value | date:'HH:mm' }}</span>
                    </button>
                    <app-time-picker [trigger]="'open-date-start'"
                      [value]="formGroup.get('start').value"
                      (changed)="onTime($event, 'start')"></app-time-picker>
                  </div>

                  <div class="form-field">
                    <label>{{ 'schedule.add.end' | translate }}</label>
                    <button class="picker-button"
                      type="button"
                      id="open-date-end">
                      <span>{{ formGroup.get('end').value | date:'HH:mm' }}</span>
                    </button>
                    <app-time-picker [trigger]="'open-date-end'"
                      [value]="formGroup.get('end').value"
                      (changed)="onTime($event, 'end')"></app-time-picker>
                  </div>
                </div>

                @if (!updating()) {
                  <label class="toggle-row">
                    <ion-toggle [value]="repeatEnabled()"
                      (ionChange)="onRepeatToggle($event)"></ion-toggle>
                    <span>{{ 'schedule.repeatAllocation' | translate }}</span>
                  </label>

                  @if (repeatEnabled()) {
                    <div class="repeat-section">
                      <div class="form-field">
                        <label>{{ 'calendar.site.repeat' | translate }}</label>
                        <ion-item lines="none">
                          <ion-select [aria-label]="'calendar.site.repeat' | translate"
                            class="full-width tw:w-full"
                            interface="popover"
                            [value]="selectedRepeatOption()?.guid ?? 'none'"
                            (ionChange)="onRepeatOptionChange($any($event.detail).value)">
                            <ion-select-option value="none">
                              {{ 'schedule.noRepeat' | translate }}
                            </ion-select-option>
                            @for (repeatOption of repeatOptions(); track repeatOption.guid) {
                              <ion-select-option [value]="repeatOption.guid">
                                {{ repeatOption.name }}
                              </ion-select-option>
                            }
                          </ion-select>
                        </ion-item>
                      </div>

                      @if (selectedRepeatOption() != null) {
                        <div class="form-grid">
                          <div class="form-field">
                            <label>{{ 'calendar.site.start' | translate }}</label>
                            <app-select-day color="secondary"
                              [id]="'adhocRepeatStart'"
                              [minDate]="minDate"
                              [name]="'calendar.site.start'"
                              size="medium"
                              [value]="$safeNavigationMigration(selectedRepeatOption()?.start)"
                              (changed)="onRepeatStartChange($event)"></app-select-day>
                          </div>

                          <div class="form-field">
                            <label>{{ 'calendar.site.end' | translate }}</label>
                            <app-select-day color="secondary"
                              [id]="'adhocRepeatEnd'"
                              [minDate]="$safeNavigationMigration(selectedRepeatOption()?.start)"
                              [name]="'calendar.site.end'"
                              size="medium"
                              [value]="$safeNavigationMigration(selectedRepeatOption()?.end)"
                              (changed)="onRepeatEndChange($event)"></app-select-day>
                          </div>
                        </div>
                      }
                    </div>
                  } @else {
                    <label class="toggle-row">
                      <ion-toggle [value]="includeWeekend()"
                        (ionChange)="onIncludeWeekend($event)"></ion-toggle>
                      <span>{{ 'schedule.includeWeekend' | translate }}</span>
                    </label>
                  }
                }
              </app-card>

              <app-card class="form-card">
                <h4>{{ 'schedule.additionalInfo' | translate }}</h4>
                @if (!isUser()) {
                  <div class="form-field">
                    <label>{{ 'schedule.resource' | translate }}</label>
                    <div class="static-field">
                      <span>{{ name() }}</span>
                    </div>
                  </div>
                }

                <div class="form-field">
                  <label>{{ 'schedule.add.text' | translate }}</label>
                  <ion-item lines="none">
                    <ion-input autocapitalize="on"
                      aria-label=""
                      formControlName="text"
                      type="text"></ion-input>
                  </ion-item>
                </div>

                <div class="pill-actions">
                  @if (isUser() && (machines$ | async); as machines) {
                    <button class="pill-button"
                      type="button"
                      (click)="selectMacines(machines)">
                      @if (selectedMachine(); as machine) {
                        {{ machine.name }}
                      } @else {
                        {{ 'schedule.add.machine' | translate }}
                      }
                    </button>
                  }

                  @if (isUser()) {
                    <button class="pill-button"
                      type="button"
                      (click)="selectTickets()">
                      @if (selectedTickets().length > 0) {
                        {{ selectedTickets().length }} {{ 'schedule.tickets' | translate }}
                      } @else {
                        {{ 'schedule.add.tickets' | translate }}
                      }
                    </button>
                  }
                </div>
              </app-card>

              @if ((role$ | async) === 'admin') {
                <app-card class="form-card">
                  <h4>{{ 'schedule.add.cost' | translate }}</h4>
                  <div class="info-list">
                    @if (distance() > 0) {
                      <div class="info-row">
                        <span>{{ 'sites.distance' | translate }}</span>
                        <strong>{{ distance().toFixed(2) }}km</strong>
                      </div>
                    }
                    @if (dayCost(); as dayCost) {
                      <div class="info-row">
                        <span>{{ 'schedule.add.cost' | translate }}</span>
                        <strong>{{ dayCost }}€</strong>
                      </div>
                    }
                    @if (isEndCleaning()) {
                      <div class="info-row">
                        <span>{{ 'schedule.add.contract' | translate }}</span>
                        <strong>
                          @if (actualHours$ | async; as actualHours) {
                            <span>
                              {{ (actualHours / workday()) * workdayCost() }}€
                            </span>
                          }&nbsp;/ {{ scheduleSite()?.additionalInfo?.form?.totalSum }}€
                        </strong>
                      </div>
                    }
                  </div>
                </app-card>
              }
            </form>
          </div>
        } @else if (viewSegment() === 'absence') {
          <div class="allocation-form">
            <form [formGroup]="formGroup"
              class="allocation-form__body">
              <app-card class="form-card">
                <h4>{{ 'timesheet.absence' | translate }}</h4>
                <button class="pill-button"
                  type="button"
                  (click)="onAbsence()">
                  @if (formGroup.get('absence').value) {
                    <span>
                      {{ 'timesheet.absences.' + formGroup.get('absence').value | translate }}
                    </span>
                  } @else {
                    {{ 'timesheet.absence' | translate }}
                  }
                </button>
              </app-card>

              <app-card class="form-card">
                <h4>{{ 'schedule.dateRange' | translate }}</h4>
                <div class="form-grid">
                  <div class="form-field">
                    <label>{{ 'schedule.startDate' | translate }}</label>
                    <app-select-day color="secondary"
                      [id]="'selectStartDay'"
                      [format]="'d.M.'"
                      [expand]="''"
                      [minDate]="minDate"
                      [value]="formGroup.get('startDate').value"
                      (changed)="onDateChange($event, 'startDate')"></app-select-day>
                  </div>

                  <div class="form-field">
                    <label>{{ 'schedule.endDate' | translate }}</label>
                    <app-select-day color="secondary"
                      [id]="'selectEndDay'"
                      [format]="'d.M.'"
                      [expand]="''"
                      [minDate]="formGroup.get('startDate').value"
                      [value]="formGroup.get('endDate').value"
                      (changed)="onDateChange($event, 'endDate')"></app-select-day>
                  </div>
                </div>
              </app-card>
            </form>
          </div>
        }
      </div>
    </div>

    <div modalFooter>
<ion-button fill="clear"
          color="medium"
          id="allocation-cancel-button"
          (click)="dismiss()">
          {{ 'general.cancel' | translate }}
        </ion-button>
        <ion-button color="light"
          fill="solid"
          id="allocation-save-button"
          (click)="onSave()"
          [disabled]="(viewSegment() !== 'absence' && formGroup.invalid)
          || (viewSegment() === 'absence' && formGroup.get('absence').value == null)">
          {{ 'general.save' | translate }}
        </ion-button>
</div>
  </app-modal-shell>
